import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let SplashclassImprovements = class SplashclassImprovements extends VuexModule {
    constructor() {
        super(...arguments);
        this.splashclassImprovements = [];
        this.cachedVersion = 0;
    }
    async fetchSplashclassImprovements() {
        const { data: splashclassImprovements, cachedVersion } = await fetchFromCache(this, 'splashclassImprovements', 'splashclassImprovement');
        return { splashclassImprovements, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['splashclassImprovements', 'cachedVersion'] })
], SplashclassImprovements.prototype, "fetchSplashclassImprovements", null);
SplashclassImprovements = __decorate([
    Module({ namespaced: true, name: 'splashclassImprovements' })
], SplashclassImprovements);
export default SplashclassImprovements;
